import { ThemeProperties } from '../../core';

export interface AvatarTheme {
	background: string;
	iconBackground: string;
	iconColor: string;
	fallbackBackground: string;
	fallbackColor: string;
}
export const theme = new ThemeProperties('avatar');
